<section class="container pia-helpBlock pia-mainContainerBlock">
  <div class="row">
    <div class="pia-breadcrumb small-12 medium-12 columns">
      <strong
        >{{ "header.help.title" | translate }} >
        {{ "header.help.manual" | translate }}</strong
      >
    </div>

    <div class="small-12 medium-3 columns">
      <aside class="pia-leftSidebarBlock pia-help-section">
        <div class="pia-sectionBlock-header">
          <h1>{{ "help.title" | translate }}</h1>
          <a
            class="pia-icons pia-icon-close-big"
            routerlink="/entries"
            title="{{ 'pia.sections.homepage_link' | translate }}"
            href="#/entries"
          ></a>
        </div>
        @for (data of tableOfTitles; track data) {
        <div>
          <div class="pia-sectionBlock-title">
            {{ data[0] }}
            <hr />
          </div>
          <ul class="pia-sectionBlock-list">
            @for (subTitle of data[1]; track subTitle) {
            <li [ngClass]="{ active: subTitle === activeElement }">
              <a href="javascript:;" (click)="getAnchor($event, subTitle)">{{
                subTitle
              }}</a>
            </li>
            }
          </ul>
        </div>
        }
      </aside>
    </div>
    <div class="small-12 medium-9 columns">
      <div class="pia-helpBlock-content" [innerHTML]="content"></div>
    </div>
  </div>
</section>
